// extracted by mini-css-extract-plugin
export var close = "ScreenOrientation-module--close--uJDIi";
export var inner = "ScreenOrientation-module--inner--A68vn";
export var isClose = "ScreenOrientation-module--isClose--FQK54";
export var message = "ScreenOrientation-module--message--+ZkOw";
export var wrapper = "ScreenOrientation-module--wrapper--Wpn5n";